module.exports = __webpack_public_path__ + "static/media/filter_on.7c3ac283.png";